import { MinusCircleOutlined, PlusOutlined, UploadOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Checkbox, Col, Collapse, Form, Input, Radio, Row, Select, message, Upload, Divider } from 'antd';
import { useState, useEffect } from 'react';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
//import AutoOpenSelect from '../../../SelectComponent/AutoOpenSelect';
import AutoOpenSelect from '../SelectComponent/AutoOpenSelect';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
//import { ReactComponent as Back } from '../../../Images/Back.svg';
// import { fetchAlloysList, resetAlloyList } from '../../../slices/alloy';
// import { fetchTempersList, resetCurrentTemperPage, resetTempersList } from '../../../slices/tempers';
// import { fetchjobWorkList, resetJobWorkList } from '../../../slices/job-work';
//import { createInquiry } from '../../../slices/inquiry';
import { createOpenInquiry } from '../../slices/inquiry';
import Logo from '../../Images/aluka-extrusion.png';

const { Option } = Select;
const { Panel } = Collapse;

function OpenInquiry() {
  const [form] = Form.useForm();
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [activePanels, setActivePanels] = useState(['1', '2', '3', '4', '5']);
  const { loading } = useSelector(state => state.inquiry);
  // const { list: alloyList, loading: alloyLoading } = useSelector(state => state.alloy);
  // const { list: temperList, loading: temperLoading } = useSelector(state => state.temper);
  // const { jobWorkdata, loading: jobWorkLoading } = useSelector(state => state.jobWork);

  // useEffect(() => {
  //   dispatch(resetAlloyList());
  //   dispatch(resetTempersList());
  //   dispatch(resetCurrentTemperPage());
  //   dispatch(resetJobWorkList());
  //   dispatch(fetchAlloysList({ page: 1, pagesize: 1000 }));
  //   dispatch(fetchTempersList({ page: 1, pagesize: 1000 }))
  //   dispatch(fetchjobWorkList());
  // }, [dispatch]);

  const normFile = (e) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList;
  };


  const handleFinish = values => {

    const cleanedInquiryDetails = values.inquiry_details.map(item => {
      const newItem = { ...item };

      // Keep only checked Engineering options and their prices
      ["cutting", "machining", "deburring"].forEach(opt => {
        if (!newItem[opt]) {
          delete newItem[opt];
          //delete newItem[`${opt}_price`];
        }
      });

      ["anodising", "powder_coating", "pvdf"].forEach(opt => {
        if (!newItem[opt]) {
          delete newItem[opt];
          delete newItem[`${opt}_description`];
          //delete newItem[`${opt}_price`];
        }
      });

      // // Similarly, remove Laser Marking fields if not selected
      // if (!item.laser_marking_description && !item.laser_marking_price) {
      //   delete newItem.laser_marking_description;
      //   delete newItem.laser_marking_price;
      // }

      return newItem;
    });
    values.inquiry_details = cleanedInquiryDetails;

    dispatch(createOpenInquiry({ payload: values }))
      .unwrap()
      .then(result => {
        if (result.success) {
          message.success('Enquiry Created Successfully.');
         window.location.href = 'https://aluka.aluxerp.com/inquiry';
        }
      })
      .catch(error => {
        if (typeof error === 'object' && error !== null) {
          const messages = [];
          for (const key in error) {
            if (Array.isArray(error[key])) {
              messages.push(`${key}: ${error[key].join(', ')}`);
            }
          }

          if (messages.length > 0) {
            message.error(messages.join('; '));
          } else {
            message.error('An unknown error occurred.');
          }
        } else if (typeof error === 'string') {
          message.error(error);
        } else if (error instanceof Error) {
          message.error(error.message);
        } else {
          message.error('An unknown error occurred.');
        }
      });
  };

  const onFinishFailed = errorInfo => {
    const errorFields = errorInfo.errorFields.map(field => field.name[0]);

    const panelMap = {
      customer_name: '1',
      inquiry_contact_persons: '2',
      inquiry_details: '3',
      initial_requirement: '4',
      annual_requirement: '4',
    };

    const panelsToOpen = [
      ...new Set(errorFields.map(field => panelMap[field]).filter(Boolean)),
    ];

    setActivePanels(panelsToOpen);
  };

  return (
    <>
      <div className="sticyaction">
        <img
            className="widhout-collapsed-logo"
            src={Logo}
            alt="logo"
          ></img>
          <Divider/>
        <div className="pagenamerow">
          <h2>Add Enquiry</h2>
          
        </div>
      </div>
      <div className="formwrapper">
        <Form
          layout="vertical"
          form={form}
          onFinish={handleFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          initialValues={{
            contact_persons: [
              {
                name: '',
                designation: '',
                email: '',
                mobile: '',
              },
            ],
            inquiry_details: [
              {
                section_no: '',
                description: '',
                drawing_file: [],
                standard_confirmation: null,
                alloy: null,
                temper: null,
                length: '',
                tolerance_minus: null,
                tolerance_plus: null,
                surface_finish: [],
                post_operation: null,
                end_application: ''
              },
            ],
            inquiry_source: 'open_form',
            source_of_inquiry_detail: [],
          }}
        >
          <Collapse activeKey={activePanels} onChange={setActivePanels} className="mb-4">
            <Panel header="Customer Details" key="1" forceRender={true}>
              <Row gutter={16}>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item label="Customer Name" name="customer_name" rules={[
                    { required: true, message: 'Please enter Customer name' },
                    { pattern: /^[A-Za-z\s]+$/, message: "Customer Name can only contain letters and spaces" },
                  ]}>
                    <Input placeholder="Enter Customer Name" />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>
          <Collapse activeKey={activePanels} onChange={setActivePanels} className="mb-4">
            <Panel header="Contact Persons" key="2" forceRender={true}>
              <Form.List name="contact_persons">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }, index) => (
                      <Row
                        className="rowItem mx-0"
                        gutter={[24, 24]}
                        align="middle"
                        key={key}
                        wrap={false}
                      >
                        <Col flex="auto">
                          <Row gutter={16}>
                            <Col xs={24} sm={12} md={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'name']}
                                label="Name"
                                rules={[
                                  { required: true, message: 'Please enter valid name' },
                                  { pattern: /^[A-Za-z\s]+$/, message: "Name can only contain letters and spaces" },
                                ]}
                              >
                                <Input
                                  placeholder="Enter Name"
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'designation']}
                                label="Designation"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please enter valid designation',
                                  },
                                  {
                                    pattern: /^[a-zA-Z\s]+$/,
                                    message: 'Please enter valid designation',
                                  },
                                ]}
                              >
                                <Input
                                  placeholder="Enter Designation"
                                />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={8} xl={6}>
                              <Form.Item
                                {...restField}
                                name={[name, 'email']}
                                label="Email"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Email is required',
                                  },
                                  {
                                    type: 'email',
                                    message: 'Please enter a valid email address',
                                  },
                                ]}
                              >
                                <Input placeholder="Enter Email" />
                              </Form.Item>
                            </Col>
                            <Col xs={24} sm={12} md={4}>
                              <Form.Item
                                {...restField}
                                name={[name, 'mobile']}
                                label="Mobile Number"
                                rules={[
                                  {
                                    required: true,
                                    message: 'Please input your phone number!',
                                  },
                                ]}
                              >
                                <PhoneInput
                                  country="in"
                                  enableSearch
                                  placeholder="Enter phone number"
                                />
                              </Form.Item>
                            </Col>

                            
                          </Row>
                        </Col>

                        <div className="addwrp">
                          {index !== 0 && (
                            <Button
                              type="primary"
                              icon={<MinusCircleOutlined />}
                              onClick={() => remove(name)}
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                marginTop: '18px',
                                marginLeft: '-29px',
                              }}
                            />
                          )}
                        </div>
                      </Row>
                    ))}
                     <Form.Item>
                                <div
                                  className="w-100 flex justify-end "
                                >
                                  <Button
                                    type="primary"
                                    onClick={() => {
                                      if (fields.length < 15) {
                                        add();
                                      } else {
                                        message.error(
                                          'You can only add up to 15 records.',
                                        );
                                      }
                                    }}
                                    icon={<PlusOutlined />}
                                  >
                                    Add Contact Person
                                  </Button>
                                </div>
                              </Form.Item>
                  </>
                )}
              </Form.List>
            </Panel>
          </Collapse>
          <Collapse activeKey={activePanels} onChange={setActivePanels} className="mb-4">
            <Panel header="Technical Details" key="3" forceRender={true}>
              <Form.List name="inquiry_details">
                {(fields, { add, remove }) => (
                  <>
                    {fields.map(({ key, name, ...restField }, index) => (
                      <>
                        <Row
                          gutter={[24, 24]}
                          className="rowItem mx-0"
                          align="middle"
                          key={key}
                          wrap={false}
                          style={{ width: '100%' }}
                        >
                          <Col flex="auto">
                            <Row gutter={[16]} key={key}>
                              <Col xs={12} md={8} xl={6} xxl={4}>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'section_no']}
                                  label="Section / Drawing / Part No."
                                  rules={[
                                    { required: true, message: 'Please enter section' },
                                    { pattern: /^[a-zA-Z0-9-/]+$/, message: "Only letters, numbers, hyphen (-) and slash (/) are allowed" },
                                  ]}
                                >
                                  <Input placeholder="Enter section/drawing/part no" />
                                </Form.Item>
                              </Col>
                              <Col xs={12} md={8} xl={6} xxl={4}>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'description']}
                                  label="Description"
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Please enter description ',
                                    },
                                  ]}
                                >
                                  <Input placeholder="Enter description" />
                                </Form.Item>
                              </Col>
                              <Col xs={12} md={4} xl={6} xxl={4}>
                                <Form.Item
                                  {...restField}
                                  label="Drawing File"
                                  name={[name, 'drawing_file']}
                                  getValueFromEvent={normFile}
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please upload a drawing file'
                                    },
                                    {
                                      validator: (_, fileList) => {

                                        // Extended file types for extrusion company
                                        const allowedExtensions = /\.(pdf|jpe?g|png|dwg|dxf|step|stp|igs|iges|stl|sat|x_t|x_b|prt|sldprt|slddrw|ipt|dwf|dwfx)$/i;

                                        for (let file of fileList) {
                                          const fileName = file?.originFileObj?.name || file.name;

                                          if (!allowedExtensions.test(fileName)) {
                                            return Promise.reject(
                                              new Error("Invalid file type. Allowed: PDF, Images, CAD files (DWG, DXF, STEP, IGES, STL, etc.)")
                                            );
                                          }
                                        }

                                        return Promise.resolve();
                                      },
                                    },
                                  ]}
                                >
                                  <Upload
                                    beforeUpload={() => false}
                                    maxCount={1}
                                    accept=".pdf,.jpeg,.jpg,.png,.dwg,.dxf,.step,.stp,.igs,.iges,.stl,.sat,.x_t,.x_b,.prt,.sldprt,.slddrw,.ipt,.dwf,.dwfx"
                                    onChange={(info) => {
                                      const allowedExtensions = /\.(pdf|jpe?g|png|dwg|dxf|step|stp|igs|iges|stl|sat|x_t|x_b|prt|sldprt|slddrw|ipt|dwf|dwfx)$/i;
                                      const file = info.fileList[info.fileList.length - 1];

                                      if (file) {
                                        const fileName = file?.originFileObj?.name || file.name;

                                        if (!allowedExtensions.test(fileName)) {
                                          message.error("Invalid file type. Allowed: PDF, Images, CAD files (DWG, DXF, STEP, IGES, STL, etc.)");
                                          // Don't proceed with invalid file
                                          return;
                                        }
                                      }

                                      // Trigger validation for this specific field in the Form.List
                                      const fieldName = ['inquiry_details', name, 'drawing_file'];
                                      form.setFieldValue(fieldName, info.fileList);
                                      form.validateFields([fieldName]);
                                    }}>
                                    <Button icon={<UploadOutlined />}>Upload</Button>
                                    <label className="filenote">
                                      Upload PDF, Images, CAD files (DWG, DXF, STEP, IGES, STL, etc. file
                                    </label>
                                  </Upload>
                                </Form.Item>
                              </Col>
                              <Col xs={12} md={8} xl={4} xxl={4}>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'standard_confirmation']}
                                  label="Standard Confirmation"
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Please select Standard Confirmation',
                                    },
                                  ]}
                                >
                                  <Select placeholder="Select Standard Confirmation">
                                    <Select.Option value="EN">EN</Select.Option>
                                    <Select.Option value="IS">IS</Select.Option>
                                    <Select.Option value="ASTM">ASTM</Select.Option>
                                    <Select.Option value="JIS">JIS</Select.Option>
                                    <Select.Option value="Others">Others</Select.Option>
                                  </Select>
                                </Form.Item>
                              </Col>

                              <Form.Item
                                shouldUpdate={(prevValues, currentValues) =>
                                  prevValues.inquiry_details?.[index]?.standard_confirmation !==
                                  currentValues.inquiry_details?.[index]?.standard_confirmation
                                }
                                noStyle
                              >
                                {({ getFieldValue }) =>
                                  getFieldValue(["inquiry_details", index, "standard_confirmation"]) === "Others" ? (
                                    <Col xs={12} md={8} xl={6}>
                                      <Form.Item
                                        {...restField}
                                        name={[name, "standard_confirmation_other"]}
                                        label="Please Specify Other Standard Confirmation"
                                        rules={[
                                          { required: true, message: "Please specify other standard confirmation" },
                                        ]}
                                      >
                                        <Input placeholder="Enter other standard confirmation" />
                                      </Form.Item>
                                    </Col>
                                  ) : null
                                }
                              </Form.Item>
                              <Col xs={12} md={8} xl={4} xxl={4}>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'alloy']}
                                  label="Alloy"
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please select alloy',
                                    },
                                  ]}
                                >
                                   <Input placeholder="Enter alloy" />
                                  {/* <Select placeholder="Select Alloy" loading={alloyLoading} disabled={alloyLoading} showSearch optionFilterProp="children">
                                    {alloyList.map((item, index) => (
                                      <Select.Option key={index} value={item.id}>
                                        {item.name} - {item.color_code}
                                      </Select.Option>
                                    ))}
                                  </Select> */}
                                </Form.Item>
                              </Col>
                              <Col xs={12} md={8} xl={6} xxl={4}>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'temper']}
                                  label="Temper"
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please select temper',
                                    },
                                  ]}
                                >
                                   <Input placeholder="Enter temper" />
                                  {/* <Select placeholder="Select Temper" loading={temperLoading} disabled={temperLoading} showSearch optionFilterProp="children">
                                    {temperList.map((item, index) => (
                                      <Select.Option key={index} value={item.id}>
                                        {item.name} - {item.code}
                                      </Select.Option>
                                    ))}
                                  </Select> */}
                                </Form.Item>
                              </Col>
                              <Col xs={12} md={8} xl={4} xxl={4}>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'length']}
                                  label="Cut Length (mm)"
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please enter cut length',
                                    },
                                    {
                                      pattern: /^\d{3,4}$/,
                                      message: "Please enter a 3 or 4 digit number",
                                    },
                                  ]}
                                >
                                  <Input placeholder="0" />
                                </Form.Item>
                              </Col>
                              <Col xs={12} md={8} xl={4} xxl={4}>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'tolerance_minus']}
                                  label={`Tolerance (mm) -`}
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Please enter minus tolerance',
                                    },
                                    {
                                      pattern: /^[+-]?\d+(\.\d+)?$/,
                                      message: "Please enter a valid number, optionally with + or -",
                                    },
                                  ]}
                                >
                                  <Input placeholder="0" />
                                </Form.Item>
                              </Col>
                              <Col>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'tolerance_plus']}
                                  label="Tolernace (mm) +"
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Please enter plus tolerance',
                                    },
                                    {
                                      pattern: /^[+-]?\d+(\.\d+)?$/,
                                      message: "Please enter a valid number, optionally with + or -",
                                    },
                                  ]}
                                >
                                  <Input placeholder="0" />
                                </Form.Item>
                              </Col>
                              <Col xs={12} md={8} xl={4} xxl={4}>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'post_operation']}
                                  label="Post Operation"
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Please select post operation',
                                    },
                                  ]}
                                >
                                  <Select placeholder="Select Post Operation"
                                    onChange={(value) => {
                                      if (value !== "Others") {
                                        // Safely remove the "Others" field from array
                                        const details = form.getFieldValue("inquiry_details") || [];
                                        if (details[index]?.post_operation_other) {
                                          const newDetails = [...details];
                                          delete newDetails[index].post_operation_other;
                                          form.setFieldsValue({ inquiry_details: newDetails });
                                        }
                                      }
                                    }}
                                  >
                                    <Select.Option value="Banding">Banding</Select.Option>
                                    <Select.Option value="Drilling">Drilling</Select.Option>
                                    <Select.Option value="Punching">Punching</Select.Option>
                                    <Select.Option value="Machining">Machining</Select.Option>
                                    <Select.Option value="Tapping">Tapping</Select.Option>
                                    <Select.Option value="Others">Others</Select.Option>
                                  </Select>
                                </Form.Item>
                              </Col>
                              <Form.Item
                                shouldUpdate={(prevValues, currentValues) =>
                                  prevValues.inquiry_details?.[index]?.post_operation !==
                                  currentValues.inquiry_details?.[index]?.post_operation
                                }
                                noStyle
                              >
                                {({ getFieldValue }) =>
                                  getFieldValue(["inquiry_details", index, "post_operation"]) === "Others" ? (
                                    <Col xs={12} md={8} xl={4}>
                                      <Form.Item
                                        {...restField}
                                        name={[name, "post_operation_other"]}
                                        label="Please Specify Other Operation"
                                        rules={[
                                          { required: true, message: "Please specify other operation" },
                                        ]}
                                      >
                                        <Input placeholder="Enter other post operation" />
                                      </Form.Item>
                                    </Col>
                                  ) : null
                                }
                              </Form.Item>
                              <Col xs={12} md={8} xl={6} xxl={4}>
                                <Form.Item
                                  {...restField}
                                  name={[name, 'end_application']}
                                  label="End Application"
                                  rules={[
                                    {
                                      required: true,
                                      message: 'Please enter end application ',
                                    },
                                  ]}
                                >
                                  <Input placeholder="Enter end application" />
                                </Form.Item>
                              </Col>
                              <Col xs={12} md={8} xl={6} xxl={4}>
                                <Form.Item
                                  {...restField}
                                  label="Surface Finish"
                                  name={[name, 'surface_finish']}
                                  rules={[
                                    {
                                      required: false,
                                      message: 'Please select Surface Finish',
                                    },
                                  ]}
                                >
                                 <Input placeholder="Enter surface finish" />
                                </Form.Item>
                              </Col>

                              
                            </Row>
                          </Col>
                          <Col>
                            <div className="addwrp">
                              {index !== 0 && (
                                <Button
                                  type="primary"
                                  danger
                                  icon={<MinusCircleOutlined />}
                                  onClick={() => remove(name)}
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                  }}
                                />
                              )}
                            </div>
                          </Col>
                        </Row>
                      </>
                    ))}
                    <Form.Item>
                      <div className="w-100 flex justify-end ">
                        <Button
                          type="primary"
                          onClick={() => {
                            if (fields.length < 500) {

                              add({ surface_finish: [] });
                            } else {
                              message.error('You can only add up to 15 records.');
                            }
                          }}
                          icon={<PlusOutlined />}
                        >
                          Add Item
                        </Button>
                      </div>
                    </Form.Item>
                  </>
                )}
              </Form.List>
            </Panel>
          </Collapse>
          <Collapse
            activeKey={activePanels}
            onChange={setActivePanels}
            className="mb-4"
          >
            <Panel header="Quantity Details" key="4" forceRender={true}>
              <Row gutter={16}>
                <Col xs={24} sm={12} md={6} lg={6}>
                  <Form.Item
                    label="Initial Requirement (Kgs)"
                    name="initial_requirement"
                    rules={[
                      {
                        pattern: /^\d+(\.\d+)?$/,
                        message: "Please enter a valid number (decimals allowed)",
                      },
                      {
                        validator: (_, value) => {
                          const maxValue = 100000;
                          if (value && parseFloat(value) > maxValue) {
                            return Promise.reject(
                              new Error(`Value cannot exceed ${maxValue} Kgs`)
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input placeholder="Enter initial requirement" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6} lg={6}>
                  <Form.Item
                    label="Annual Requirement (Kgs)"
                    name="annual_requirement"
                    rules={[
                      {
                        pattern: /^\d+(\.\d+)?$/,
                        message: "Please enter a valid number (decimals allowed)",
                      },
                      {
                        validator: (_, value) => {
                          const maxValue = 100000;
                          if (value && parseFloat(value) > maxValue) {
                            return Promise.reject(
                              new Error(`Value cannot exceed ${maxValue} Kgs`)
                            );
                          }
                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Input placeholder="Enter annual requirement" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6} lg={6}>
                  <Form.Item
                    label="Source of Inquiry"
                    name="inquiry_source"
                  >
                    <Radio.Group>
                      <Radio value="Open_Form">Open Form</Radio>
                      <Radio value="Whatsapp">Whatsapp</Radio>
                      <Radio value="Email">Email</Radio>
                      <Radio value="Call">Call</Radio>
                      <Radio value="Expo">Expo</Radio>
                      <Radio value="Reference">Reference</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={6} lg={6}>
                  <Form.Item
                    name="source_of_inquiry_detail"
                    label="Source of Inquiry Attachment"
                    valuePropName="fileList"
                    getValueFromEvent={(e) => e?.fileList || []}
                    rules={[
                      {
                        validator: (_, fileList) => {
                          // If no files uploaded, it's valid (since field is not required)
                          if (!fileList || fileList.length === 0) {
                            return Promise.resolve();
                          }

                          const allowedExtensions = /\.(pdf|jpe?g|png)$/i;

                          for (let file of fileList) {
                            // Check file name from either originFileObj or file itself
                            const fileName = file?.originFileObj?.name || file.name;

                            if (!allowedExtensions.test(fileName)) {
                              return Promise.reject(
                                new Error("Only PDF, JPEG, JPG, or PNG files are allowed")
                              );
                            }
                          }

                          return Promise.resolve();
                        },
                      },
                    ]}
                  >
                    <Upload
                      name="file"
                      listType="picture"
                      accept=".pdf,.jpeg,.jpg,.png"
                      maxCount={1}
                      beforeUpload={() => false}
                      onChange={(info) => {
                        // const allowedExtensions = /\.(pdf|jpe?g|png)$/i;
                        // const file = info.fileList[info.fileList.length - 1];

                        // if (file) {
                        //   const fileName = file?.originFileObj?.name || file.name;

                        //   if (!allowedExtensions.test(fileName)) {
                        //     message.error("Only PDF, JPEG, JPG, or PNG files are allowed");
                        //     // Don't update the form field with invalid file
                        //     return;
                        //   }
                        // }

                        // Update form field and trigger validation
                        form.setFieldValue("source_of_inquiry_detail", info.fileList);
                        form.validateFields(['source_of_inquiry_detail']);
                      }}>
                      <Button icon={<UploadOutlined />}>Upload</Button>
                    </Upload>
                    <label className="filenote">
                      Upload PDF, JPEG, JPG or PNG file
                    </label>
                  </Form.Item>

                </Col>
              </Row>
            </Panel>
          </Collapse>
          <Collapse
            activeKey={activePanels}
            onChange={setActivePanels}
            className="mb-4"
          >
            <Panel
              header="Other Relevant Information"
              key="5"
              forceRender={true}
            >
              <Row gutter={16}>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item label="Special Notes" name="special_notes">
                    <Input placeholder="Enter special notes" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item
                    label="Certifications Required"
                    name="certifications_required"
                  >
                    <Input placeholder="Enter required certifications" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item
                    label="Packaging Requirements"
                    name="packaging_requirements"
                  >
                    <Input placeholder="Enter packaging requirements" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6}>
                  <Form.Item
                    label="Additional Notes"
                    name="additional_notes"
                  >
                    <Input placeholder="Enter additional notes" />
                  </Form.Item>
                </Col>
              </Row>
            </Panel>
          </Collapse>
          <div className="flex justify-end">
            <Button type="primary" htmlType="submit" size="large" loading={loading} >
              Create Inquiry
            </Button>
          </div>
        </Form>
      </div>
    </>
  );
}

export default OpenInquiry;